import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=05db95b6&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=05db95b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db95b6",
  null
  
)

export default component.exports